import orderBy from 'lodash.orderby';
import * as z from 'zod';

const agreementStatus = [
  'In Progress',
  'Awaiting Submission',
  'Sent to Client',
  'Pending Approval',
  'Execution',
  'Canceled',
  'Hold',
  'Lost',
  'Long Term Success',
  'Draft',
  'Executed',
  'Active',
] as const;

export const agreementStatusQuerySchema = z.enum(agreementStatus);

export type AgreementStatusQuerySchema = z.infer<typeof agreementStatusQuerySchema>;
export type AgreementStatusMutationSchema = AgreementStatusQuerySchema;

export const agreementStatusFormSchema = z.object({
  name: z.string(),
  value: agreementStatusQuerySchema,
});

type AgreementStatusFormSchema = z.infer<typeof agreementStatusFormSchema>;

export const defaultAgreementStatus = null;

export const agreementStatusOptions = (isAddendum?: boolean) => {
  const s = orderBy(
    agreementStatus.map((value) => ({
      name: value,
      value,
    })),
    ['name']
  );
  if (typeof isAddendum === 'undefined') {
    return s;
  }

  if (isAddendum) {
    return s.filter((option) => option.value === 'Draft' || option.value === 'Executed');
  } else {
    return s.filter((option) => option.value !== 'Draft' && option.value !== 'Executed');
  }
};

export function agreementStatusToStr(p?: AgreementStatusFormSchema | null) {
  return p?.value ?? null;
}

export function strToAgreementStatus(p: AgreementStatusQuerySchema | null): AgreementStatusFormSchema | null {
  // if prop not passed it will generate all options
  return agreementStatusOptions().find((option) => option?.value === p) ?? null;
}
